((w: Window, g: typeof global, gt: typeof globalThis): void => {
  // Monkey patch the global Reflect object within this scope
  const originalReflect = gt.Reflect ?? g.Reflect ?? w.Reflect;
  g.Reflect = undefined as unknown as typeof Reflect;
  gt.Reflect = undefined as unknown as typeof Reflect;
  w.Reflect = undefined as unknown as typeof Reflect;

  // Load reflect-metadata, which will populate the local Reflect object
  require('reflect-metadata');

  w.Reflect = w.Reflect ?? gt.Reflect ?? g.Reflect;
  gt.Reflect = gt.Reflect ?? w.Reflect ?? g.Reflect;
  g.Reflect = g.Reflect ?? w.Reflect ?? gt.Reflect;

  // eslint-disable-next-line node/no-missing-require,@typescript-eslint/no-var-requires
  require('./init').runApplication(w);

  // Restore the original Reflect object to the global scope
  w.Reflect = originalReflect;
  g.Reflect = originalReflect;
  gt.Reflect = originalReflect;
})(
  window,
  typeof global !== 'undefined' ? global : {} as typeof global,
  typeof globalThis !== 'undefined' ? globalThis : {} as typeof globalThis,
);
